
import React, { useState, useEffect } from "react";
import { Button, Empty, Select } from "antd";
import "./evalanalytics.scss";
import StackBarChart from "../StackBarChart";
import PieChart from "../StackBarChart/Pie"
import useQCEStore from "../../store/qce.store";




function EvalAnalytics() {
  const [currentEvalStats, setEvalStats] = useState({});
  const [currentEvalCategoryStats, setEvalCategoryStats] = useState({});
  const [category, setCurrentCategory] = useState("IT");
  const { getEvalStats, getEvalCategoryStats, evalStats, evalCategoryStats, domainArr } = useQCEStore();
  console.log("evalCategoryStats", evalCategoryStats);
  
  let graphArray = domainArr ? domainArr[category] : [];
  if (graphArray && graphArray.length > 0) {
    graphArray = ['assessment', ...graphArray];
  }
  if (graphArray && graphArray.length > 0) {
    graphArray = graphArray.sort((a, b) => {
      const isFrameworkOrProgramming = (item) => 
        item.toLowerCase().includes('framework') || item.toLowerCase().includes('programming');
      
      if (isFrameworkOrProgramming(a) && !isFrameworkOrProgramming(b)) return 1;
      if (!isFrameworkOrProgramming(a) && isFrameworkOrProgramming(b)) return -1;
      return 0;
    });
  }
  console.log("graphArray", graphArray);
  


   useEffect(() => {
    getEvalStats(setEvalStats);
  }, []);
  
  useEffect(() => {
    if (domainArr && Object.keys(domainArr).length > 0) {
      setCurrentCategory(Object.keys(domainArr)[0]);
    }
  }, [domainArr]);
  useEffect(() => {
    
    getEvalCategoryStats({ category }, setEvalCategoryStats)
    
  }, [category, evalStats]);
  

  const changeCatategory = (value) => {
    setCurrentCategory(value);
    
  }

  if (!evalStats || evalStats.length === 0) {
    return <Empty description="No Evaluation Stats Available" />;
  }

  if (!evalCategoryStats || Object.keys(evalCategoryStats).length === 0) {
    return <Empty description="No Evaluation Category Stats Available" />;
  }


  /////Evaluations Stats/////////

  const categories = evalStats || [];

  const filteredCategories = categories.filter(
    stat => stat.qcount > 0 || stat.ecount > 0 || stat.acount > 0
  );

  const evalStatsLabels = filteredCategories.map(stat => stat.category);

  // build a lookup for O(1) access
  const categoryMap = Object.fromEntries(
    categories.map(stat => [stat.category, stat])
  );

  const getDataArray = (key) =>
    evalStatsLabels.map(label => categoryMap[label]?.[key] ?? 0);

  const ecountData = getDataArray("ecount");
  const qcountData = getDataArray("qcount");
  const acountData = getDataArray("acount");

  const makeChart = (labels, data, label, color) => ({
    labels,
    datasets: [
      {
        label,
        data,
        backgroundColor: color,
      },
    ],
  });
  const evalBarChartData = makeChart(evalStatsLabels, ecountData, evalStatsLabels, "rgba(75, 192, 192)");
  const totalquestionBarchart = makeChart(evalStatsLabels, qcountData, evalStatsLabels, "rgba(153, 102, 255)");
  const totalcandidatesBarchart = makeChart(evalStatsLabels, acountData, evalStatsLabels, "rgba(255, 159, 64)");

  return (
    <div className="eval-analytics-container">
      <div className="eval-title-chart-container">
      Evaluations Stats
      </div>

      <div className="eval-title-chart-container">
      <div className="eval-analytics-stackChart-wrapper">
      <StackBarChart stackBarData={evalBarChartData}
      stack={false}
      showTitle={"Eval Category"}
      MAX={100} />
      </div>
      <div className="eval-analytics-stackChart-wrapper">
      <StackBarChart stackBarData={totalquestionBarchart}
      stack={false}
      showTitle={"Total Questions"}
      MAX={100} />
      </div>
      <div className="eval-analytics-stackChart-wrapper">
      <StackBarChart stackBarData={totalcandidatesBarchart}
      stack={false}
      showTitle={"Total Candidates"}
      MAX={100} />
      </div>
      </div>
      <div className="eval-analytics-stats-containers">
      <Select
      value={category}
      onChange={changeCatategory}
      style={{ width: 200 }}
      placeholder="Select Eval Category"
      >
      {Object.keys(domainArr || {}).map(domain => (
      <Select.Option key={domain} value={domain}>
      {domain}
      </Select.Option>
      ))}
      </Select>
      </div>
      
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
      {graphArray && graphArray.map((graphType, index) => {
     
      if (!graphType) {
      return null;
      }

      const statKey = `${graphType.toLowerCase()}stat`;
      const data = evalCategoryStats?.[graphType] || {};
      const labels = Object.keys(data);
      const values = Object.values(data);
      const chartData = makeChart(labels, values, graphType[0], `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)})`);
      
      const isProgrammingOrFramework = graphType.toLowerCase().includes('programming') || graphType.toLowerCase().includes('framework');
      
      return (
      <div key={index} className="eval-analytics-stats-containers" style={{ flex: '1 1 calc(33.333% - 16px)', minWidth: '300px' }}>
      <div className="eval-analytics-stackChart-wrapper">
       {isProgrammingOrFramework ? (
      <PieChart 
      stackBarData={chartData}
      stack={false}
      showTitle={graphType}
      MAX={100} 
      />
       ) : (
      <StackBarChart 
      stackBarData={chartData}
      stack={false}
      showTitle={graphType}
      MAX={100} 
      />
       )}
      </div>
      </div>
      );
      })}
      </div>
    </div>
    );
}

export default EvalAnalytics;

